<template>
    <div>
        <section v-if="paso0" class="padding-vertical-content white-content right-background" id="paso-0">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 col-xl-7">
                                <div v-if="loading">
                                    <LoaderComponent/>
                                </div>
                                <h2 class="m-0 mt-5 h2 text-uppercase">{{ $t('renovar_base.renueva_base', {base: 'Cantera'}) }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_base.temporada', { temporada: lista_abonados.nombre }) }}</div>

                                <BuscarBaseComponent :front="true" :base="base_search" :error="error" :paso_activo="paso0" @terminado="buscarBase"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <PasoUnoComponent 
            v-if="paso1" 
            :base="base" 
            :codigo_invitacion="codigo_invitacion" 
            :paso_activo="paso1_activo" 
            @terminado="terminarPasoUno"
            :fields="fields.filter(field => field.pivot.deportista === true)"
        />        
        <PasoDosComponent 
            v-if="paso2" 
            :base="base" 
            :paso_activo="paso2_activo" 
            @terminado="terminarPasoDos" 
            @volver="volverPasoUno()"
            :fields="fields.filter(field => field.pivot.representante === true)"
        />        
        <PasoTresComponent v-if="paso3" :base="base" :paso_activo="paso3_activo" @terminado="terminarPasoTres()" @volver="volverPasoDos()"/>
        <PasoCuatroComponent v-if="paso4" :base="base" :paso_activo="paso4_activo" @terminado="terminarPasoCuatro()" @volver="volverPasoTres()"/>
        <PasoCincoComponent v-if="paso5 && base.categoria_base.tiene_indumentarias" :base="base" :paso_activo="paso5_activo" @terminado="terminarPasoCinco()" @volver="volverPasoCuatro()"/>
        <PasoSeisComponent v-if="paso6" :base="base" @terminado="procesarCompra" :paso_activo="paso6_activo" />
        <ProcesarCompraComponent v-if="pago_paycomet" :base="base" />
    </div>
</template>

<script>
    import BuscarBaseComponent from '@/components/frontend/bases/renovar/BuscarBaseComponent';
    import PasoUnoComponent from "@/components/frontend/bases/PasoUnoComponent";
    import PasoDosComponent from "@/components/frontend/bases/PasoDosComponent";
    import PasoTresComponent from "@/components/frontend/bases/PasoTresComponent";
    import PasoCuatroComponent from "@/components/frontend/bases/PasoCuatroComponent";
    import PasoCincoComponent from "@/components/frontend/bases/PasoCincoComponent";
    import PasoSeisComponent from "@/components/frontend/bases/PasoSeisComponent";
    import ProcesarCompraComponent from "@/components/frontend/bases/ProcesarCompraComponent";

    export default {
        data() {
            return {
                paso0: true,
                paso1: false,
                paso1_activo: false,
                paso2: false,
                paso2_activo: false,
                paso3: false,
                paso3_activo: false,
                paso4: false,
                paso4_activo: false,
                paso5: false,
                paso5_activo: false,
                paso6: false,
                paso6_activo: false,
                base_search: {
                    dni: null,
                },
                base: null,
                error: false,
                loading: false,
                pago_paycomet: false,
                codigo_invitacion: null
            }
        },
        created() {
            if (this.manager.activar_compra_por_invitacion_bases) {
                this.codigo_invitacion  = localStorage.getItem('codigo_invitacion');
                localStorage.removeItem('codigo_invitacion');
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            fields() {
                return this.lista_abonados.fields_deportistas;
            }
        },
        methods: {
            buscarBase() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.base_search.dni
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.buscar'), params).then(res => {
                    this.base = res.data.base;
                    this.base.fields_deportista = {};
                    this.base.fields_responsable_1 = {};
                    this.base.fields_responsable_2 = {};
                    this.terminarPasoCero();
                }).catch(error => {
                    this.error = error.response.data.message;
                }).finally(() => this.loading = false);
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100);
            },
            terminarPasoCero() {
                this.paso1 = true;
                this.paso1_activo = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-1');
                });
            },
            volverPasoCero() {
                this.paso1 = false;
                this.paso1_activo = false,
                this.paso0 = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-0');
                });
            },
            terminarPasoUno(data) {
                this.base = data;
                this.paso2 = true;
                this.paso2_activo = true,
                this.paso1_activo = false,
                this.$nextTick(() => {
                    this.scrollTo('#paso-2');
                });
            },
            volverPasoUno() {
                this.paso2 = false;
                this.paso1_activo = true,
                this.$nextTick(() => {
                    this.scrollTo('#paso-1');
                });
            },
            terminarPasoDos(data) {
                this.base = data;
                this.paso3 = true;
                this.paso2_activo = false,
                this.paso3_activo = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-3');
                });                
            },
            volverPasoDos() {
                this.paso3 = false;
                this.paso2_activo = true,
                this.$nextTick(() => {
                    this.scrollTo('#paso-2');
                });
            },
            terminarPasoTres() {
                this.paso4 = true;
                this.paso3_activo = false,
                this.paso4_activo = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-4');
                });
            },
            volverPasoTres() {
                this.paso4 = false;
                this.paso3_activo = true,
                this.$nextTick(() => {
                    this.scrollTo('#paso-3');
                });
            },
            terminarPasoCuatro() {
                if (this.base.categoria_base.tiene_indumentarias) {
                    this.paso5 = true;
                    this.paso5_activo = true,
                    this.paso4_activo = false,
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.scrollTo('#paso-5');
                        });
                    }, 1000);
                } else {
                    this.paso6 = true;
                    this.paso6_activo = true;
                    this.paso4_activo = false;
                    this.$nextTick(() => {
                        this.scrollTo('#paso-6');
                    });
                }
            },
            volverPasoCuatro() {
                this.paso5 = false;
                this.paso4_activo = true,
                this.paso4 = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-4');
                });
            },
            terminarPasoCinco(indumentariasElegidas) {
                this.base.indumentariasElegidas = indumentariasElegidas;

                this.paso6 = true;
                this.paso6_activo = true,
                this.paso4_activo = false;
                this.$nextTick(() => {
                    this.scrollTo('#paso-6');
                });
            },
            procesarCompra() {
                this.paso6_activo = false;
                this.pago_paycomet = true;
                this.$nextTick(() => {
                    this.scrollTo('#paycometPaymentForm');
                });
            }
        },
        components: {
            BuscarBaseComponent,
            PasoUnoComponent,
            PasoDosComponent,
            PasoTresComponent,
            PasoCuatroComponent,
            PasoCincoComponent,
            PasoSeisComponent,
            ProcesarCompraComponent
        }
    }
</script>
